import { SelectOption } from '@tryhackme/thm-ui-components';

import { RoleMenuOption } from 'src/features/admin/cloud-training/azure-lab-config/azure-lab-config.types';

export const REGULAR_LAB = 'Regular Lab';
export const TENANT_LAB = 'Tenant Lab';

export const LAB_FILTER_OPTIONS: SelectOption[] = [
  { value: 'all', label: 'All' },
  { value: 'regular', label: `${REGULAR_LAB}s` },
  { value: 'mt', label: `${TENANT_LAB}s` },
];

export const AZURE_ROLE_OPTIONS: RoleMenuOption[] = [
  {
    label: 'Application Administrator',
    description: 'Can create and manage all aspects of app registrations and enterprise apps.',
    value: '9b895d92-2cd3-44c7-9d02-a6ac2d5ea5c3',
  },
  {
    label: 'Application Developer',
    description: "Can create application registrations independent of the 'Users can register applications' setting.",
    value: 'cf1c38e5-3621-4004-a7cb-879624dced7c',
  },
  {
    label: 'Attack Payload Author',
    description: 'Can create attack payloads that an administrator can initiate later.',
    value: '9c6df0f2-1e7c-4dc3-b195-66dfbd24aa8f',
  },
  {
    label: 'Attack Simulation Administrator',
    description: 'Can create and manage all aspects of attack simulation campaigns.',
    value: 'c430b396-e693-46cc-96f3-db01bf8bb62a',
  },
  {
    label: 'Attribute Assignment Administrator',
    description: 'Assign custom security attribute keys and values to supported Microsoft Entra objects.',
    value: '58a13ea3-c632-46ae-9ee0-9c0d43cd7f3d',
  },
  {
    label: 'Attribute Assignment Reader',
    description: 'Read custom security attribute keys and values for supported Microsoft Entra objects.',
    value: 'ffd52fa5-98dc-465c-991d-fc073eb59f8f',
  },
  {
    label: 'Attribute Definition Administrator',
    description: 'Define and manage the definition of custom security attributes.',
    value: '8424c6f0-a189-499e-bbd0-26c1753c96d4',
  },
  {
    label: 'Attribute Definition Reader',
    description: 'Read the definition of custom security attributes.',
    value: '1d336d2c-4ae8-42ef-9711-b3604ce3fc2c',
  },
  {
    label: 'Attribute Log Administrator',
    description: 'Read audit logs and configure diagnostic settings for events related to custom security attributes.',
    value: '5b784334-f94b-471a-a387-e7219fc49ca2',
  },
  {
    label: 'Attribute Log Reader',
    description: 'Read audit logs related to custom security attributes.',
    value: '9c99539d-8186-4804-835f-fd51ef9e2dcd',
  },
  {
    label: 'Authentication Administrator',
    description: 'Can access to view, set and reset authentication method information for any non-admin user.',
    value: 'c4e39bd9-1100-46d3-8c65-fb160da0071f',
  },
  {
    label: 'Authentication Extensibility Administrator',
    description:
      'Customize sign in and sign up experiences for users by creating and managing custom authentication extensions.',
    value: '25a516ed-2fa0-40ea-a2d0-12923a21473a',
  },
  {
    label: 'Authentication Policy Administrator',
    description:
      'Can create and manage the authentication methods policy, tenant-wide MFA settings, password protection policy, and verifiable credentials.',
    value: '0526716b-113d-4c15-b2c8-68e3c22b9f80',
  },
  {
    label: 'Azure DevOps Administrator',
    description: 'Can manage Azure DevOps policies and settings.',
    value: 'e3973bdf-4987-49ae-837a-ba8e231c7286',
  },
  {
    label: 'Azure Information Protection Administrator',
    description: 'Can manage all aspects of the Azure Information Protection product.',
    value: '7495fdc4-34c4-4d15-a289-98788ce399fd',
  },
  {
    label: 'B2C IEF Keyset Administrator',
    description: 'Can manage secrets for federation and encryption in the Identity Experience Framework (IEF).',
    value: 'aaf43236-0c0d-4d5f-883a-6955382ac081',
  },
  {
    label: 'B2C IEF Policy Administrator',
    description: 'Can create and manage trust framework policies in the Identity Experience Framework (IEF).',
    value: '3edaf663-341e-4475-9f94-5c398ef6c070',
  },
  {
    label: 'Billing Administrator',
    description: 'Can perform common billing related tasks like updating payment information.',
    value: 'b0f54661-2d74-4c50-afa3-1ec803f12efe',
  },
  {
    label: 'Cloud App Security Administrator',
    description: 'Can manage all aspects of the Defender for Cloud Apps product.',
    value: '892c5842-a9a6-463a-8041-72aa08ca3cf6',
  },
  {
    label: 'Cloud Application Administrator',
    description: 'Can create and manage all aspects of app registrations and enterprise apps except App Proxy.',
    value: '158c047a-c907-4556-b7ef-446551a6b5f7',
  },
  {
    label: 'Cloud Device Administrator',
    description: 'Limited access to manage devices in Microsoft Entra ID.',
    value: '7698a772-787b-4ac8-901f-60d6b08affd2',
  },
  {
    label: 'Compliance Administrator',
    description: 'Can read and manage compliance configuration and reports in Microsoft Entra ID and Microsoft 365.',
    value: '17315797-102d-40b4-93e0-432062caca18',
  },
  {
    label: 'Compliance Data Administrator',
    description: 'Creates and manages compliance content.',
    value: 'e6d1a23a-da11-4be4-9570-befc86d067a7',
  },
  {
    label: 'Conditional Access Administrator',
    description: 'Can manage Conditional Access capabilities.',
    value: 'b1be1c3e-b65d-4f19-8427-f6fa0d97feb9',
  },
  {
    label: 'Customer LockBox Access Approver',
    description: 'Can approve Microsoft support requests to access customer organizational data.',
    value: '5c4f9dcd-47dc-4cf7-8c9a-9e4207cbfc91',
  },
  {
    label: 'Desktop Analytics Administrator',
    description: 'Can access and manage Desktop management tools and services.',
    value: '38a96431-2bdf-4b4c-8b6e-5d3d8abac1a4',
  },
  {
    label: 'Directory Readers',
    description:
      'Can read basic directory information. Commonly used to grant directory read access to applications and guests.',
    value: '88d8e3e3-8f55-4a1e-953a-9b9898b8876b',
  },
  {
    label: 'Directory Synchronization Accounts',
    description: 'Only used by Microsoft Entra Connect service.',
    value: 'd29b2b05-8046-44ba-8758-1e26182fcf32',
  },
  {
    label: 'Directory Writers',
    description:
      'Can read and write basic directory information. For granting access to applications, not intended for users.',
    value: '9360feb5-f418-4baa-8175-e2a00bac4301',
  },
  {
    label: 'Domain Name Administrator',
    description: 'Can manage domain names in cloud and on-premises.',
    value: '8329153b-31d0-4727-b945-745eb3bc5f31',
  },
  {
    label: 'Dynamics 365 Administrator',
    description: 'Can manage all aspects of the Dynamics 365 product.',
    value: '44367163-eba1-44c3-98af-f5787879f96a',
  },
  {
    label: 'Dynamics 365 Business Central Administrator',
    description: 'Access and perform all administrative tasks on Dynamics 365 Business Central environments.',
    value: '963797fb-eb3b-4cde-8ce3-5878b3f32a3f',
  },
  {
    label: 'Edge Administrator',
    description: 'Manage all aspects of Microsoft Edge.',
    value: '3f1acade-1e04-4fbc-9b69-f0302cd84aef',
  },
  {
    label: 'Exchange Administrator',
    description: 'Can manage all aspects of the Exchange product.',
    value: '29232cdf-9323-42fd-ade2-1d097af3e4de',
  },
  {
    label: 'Exchange Recipient Administrator',
    description: 'Can create or update Exchange Online recipients within the Exchange Online organization.',
    value: '31392ffb-586c-42d1-9346-e59415a2cc4e',
  },
  {
    label: 'External ID User Flow Administrator',
    description: 'Can create and manage all aspects of user flows.',
    value: '6e591065-9bad-43ed-90f3-e9424366d2f0',
  },
  {
    label: 'External ID User Flow Attribute Administrator',
    description: 'Can create and manage the attribute schema available to all user flows.',
    value: '0f971eea-41eb-4569-a71e-57bb8a3eff1e',
  },
  {
    label: 'External Identity Provider Administrator',
    description: 'Can configure identity providers for use in direct federation.',
    value: 'be2f45a1-457d-42af-a067-6ec1fa63bc45',
  },
  {
    label: 'Fabric Administrator',
    description: 'Can manage all aspects of the Fabric and Power BI products.',
    value: 'a9ea8996-122f-4c74-9520-8edcd192826c',
  },
  {
    label: 'Global Administrator',
    description:
      'Can manage all aspects of Microsoft Entra ID and Microsoft services that use Microsoft Entra identities.',
    value: '62e90394-69f5-4237-9190-012177145e10',
  },
  {
    label: 'Global Reader',
    description: 'Can read everything that a Global Administrator can, but not update anything.',
    value: 'f2ef992c-3afb-46b9-b7cf-a126ee74c451',
  },
  {
    label: 'Global Secure Access Administrator',
    description:
      'Create and manage all aspects of Microsoft Entra Internet Access and Microsoft Entra Private Access, including managing access to public and private endpoints.',
    value: 'ac434307-12b9-4fa1-a708-88bf58caabc1',
  },
  {
    label: 'Groups Administrator',
    description:
      'Members of this role can create/manage groups, create/manage groups settings like naming and expiration policies, and view groups activity and audit reports.',
    value: 'fdd7a751-b60b-444a-984c-02652fe8fa1c',
  },
  {
    label: 'Guest Inviter',
    description: "Can invite guest users independent of the 'members can invite guests' setting.",
    value: '95e79109-95c0-4d8e-aee3-d01accf2d47b',
  },
  {
    label: 'Helpdesk Administrator',
    description: 'Can reset passwords for non-administrators and Helpdesk Administrators.',
    value: '729827e3-9c14-49f7-bb1b-9608f156bbb8',
  },
  {
    label: 'Hybrid Identity Administrator',
    description:
      'Manage Active Directory to Microsoft Entra cloud provisioning, Microsoft Entra Connect, pass-through authentication (PTA), password hash synchronization (PHS), seamless single sign-on (seamless SSO), and federation settings. Does not have access to manage Microsoft Entra Connect Health.',
    value: '8ac3fc64-6eca-42ea-9e69-59f4c7b60eb2',
  },
  {
    label: 'Identity Governance Administrator',
    description: 'Manage access using Microsoft Entra ID for identity governance scenarios.',
    value: '45d8d3c5-c802-45c6-b32a-1d70b5e1e86e',
  },
  {
    label: 'Insights Administrator',
    description: 'Has administrative access in the Microsoft 365 Insights app.',
    value: 'eb1f4a8d-243a-41f0-9fbd-c7cdf6c5ef7c',
  },
  {
    label: 'Insights Analyst',
    description: 'Access the analytical capabilities in Microsoft Viva Insights and run custom queries.',
    value: '25df335f-86eb-4119-b717-0ff02de207e9',
  },
  {
    label: 'Insights Business Leader',
    description: 'Can view and share dashboards and insights via the Microsoft 365 Insights app.',
    value: '31e939ad-9672-4796-9c2e-873181342d2d',
  },
  {
    label: 'Intune Administrator',
    description: 'Can manage all aspects of the Intune product.',
    value: '3a2c62db-5318-420d-8d74-23affee5d9d5',
  },
  {
    label: 'Kaizala Administrator',
    description: 'Can manage settings for Microsoft Kaizala.',
    value: '74ef975b-6605-40af-a5d2-b9539d836353',
  },
  {
    label: 'Knowledge Administrator',
    description: 'Can configure knowledge, learning, and other intelligent features.',
    value: 'b5a8dcf3-09d5-43a9-a639-8e29ef291470',
  },
  {
    label: 'Knowledge Manager',
    description: 'Can organize, create, manage, and promote topics and knowledge.',
    value: '744ec460-397e-42ad-a462-8b3f9747a02c',
  },
  {
    label: 'License Administrator',
    description: 'Can manage product licenses on users and groups.',
    value: '4d6ac14f-3453-41d0-bef9-a3e0c569773a',
  },
  {
    label: 'Lifecycle Workflows Administrator',
    description:
      'Create and manage all aspects of workflows and tasks associated with Lifecycle Workflows in Microsoft Entra ID.',
    value: '59d46f88-662b-457b-bceb-5c3809e5908f',
  },
  {
    label: 'Message Center Privacy Reader',
    description: 'Can read security messages and updates in Office 365 Message Center only.',
    value: 'ac16e43d-7b2d-40e0-ac05-243ff356ab5b',
  },
  {
    label: 'Message Center Reader',
    description: 'Can read messages and updates for their organization in Office 365 Message Center only.',
    value: '790c1fb9-7f7d-4f88-86a1-ef1f95c05c1b',
  },
  {
    label: 'Microsoft 365 Migration Administrator',
    description: 'Perform all migration functionality to migrate content to Microsoft 365 using Migration Manager.',
    value: '8c8b803f-96e1-4129-9349-20738d9f9652',
  },
  {
    label: 'Microsoft Entra Joined Device Local Administrator',
    description:
      'Users assigned to this role are added to the local administrators group on Microsoft Entra joined devices.',
    value: '9f06204d-73c1-4d4c-880a-6edb90606fd8',
  },
  {
    label: 'Microsoft Hardware Warranty Administrator',
    description:
      'Create and manage all aspects warranty claims and entitlements for Microsoft manufactured hardware, like Surface and HoloLens.',
    value: '1501b917-7653-4ff9-a4b5-203eaf33784f',
  },
  {
    label: 'Microsoft Hardware Warranty Specialist',
    description: 'Create and read warranty claims for Microsoft manufactured hardware, like Surface and HoloLens.',
    value: '281fe777-fb20-4fbb-b7a3-ccebce5b0d96',
  },
  {
    label: 'Modern Commerce Administrator',
    description: 'Can manage commercial purchases for a company, department or team.',
    value: 'd24aef57-1500-4070-84db-2666f29cf966',
  },
  {
    label: 'Network Administrator',
    description:
      'Can manage network locations and review enterprise network design insights for Microsoft 365 Software as a Service applications.',
    value: 'd37c8bed-0711-4417-ba38-b4abe66ce4c2',
  },
  {
    label: 'Office Apps Administrator',
    description:
      "Can manage Office apps cloud services, including policy and settings management, and manage the ability to select, unselect and publish 'what's new' feature content to end-user's devices.",
    value: '2b745bdf-0803-4d80-aa65-822c4493daac',
  },
  {
    label: 'Organizational Branding Administrator',
    description: 'Manage all aspects of organizational branding in a tenant.',
    value: '92ed04bf-c94a-4b82-9729-b799a7a4c178',
  },
  {
    label: 'Organizational Messages Approver',
    description:
      'Review, approve, or reject new organizational messages for delivery in the Microsoft 365 admin center before they are sent to users.',
    value: 'e48398e2-f4bb-4074-8f31-4586725e205b',
  },
  {
    label: 'Organizational Messages Writer',
    description:
      'Write, publish, manage, and review the organizational messages for end-users through Microsoft product surfaces.',
    value: '507f53e4-4e52-4077-abd3-d2e1558b6ea2',
  },
  {
    label: 'Password Administrator',
    description: 'Can reset passwords for non-administrators and Password Administrators.',
    value: '966707d0-3269-4727-9be2-8c3a10f19b9d',
  },
  {
    label: 'Permissions Management Administrator',
    description: 'Manage all aspects of Microsoft Entra Permissions Management.',
    value: 'af78dc32-cf4d-46f9-ba4e-4428526346b5',
  },
  {
    label: 'Power Platform Administrator',
    description: 'Can create and manage all aspects of Microsoft Dynamics 365, Power Apps and Power Automate.',
    value: '11648597-926c-4cf3-9c36-bcebb0ba8dcc',
  },
  {
    label: 'Printer Administrator',
    description: 'Can manage all aspects of printers and printer connectors.',
    value: '644ef478-e28f-4e28-b9dc-3fdde9aa0b1f',
  },
  {
    label: 'Printer Technician',
    description: 'Can register and unregister printers and update printer status.',
    value: 'e8cef6f1-e4bd-4ea8-bc07-4b8d950f4477',
  },
  {
    label: 'Privileged Authentication Administrator',
    description:
      'Can access to view, set and reset authentication method information for any user (admin or non-admin).',
    value: '7be44c8a-adaf-4e2a-84d6-ab2649e08a13',
  },
  {
    label: 'Privileged Role Administrator',
    description:
      'Can manage role assignments in Microsoft Entra ID, and all aspects of Privileged Identity Management.',
    value: 'e8611ab8-c189-46e8-94e1-60213ab1f814',
  },
  {
    label: 'Reports Reader',
    description: 'Can read sign-in and audit reports.',
    value: '4a5d8f65-41da-4de4-8968-e035b65339cf',
  },
  {
    label: 'Search Administrator',
    description: 'Can create and manage all aspects of Microsoft Search settings.',
    value: '0964bb5e-9bdb-4d7b-ac29-58e794862a40',
  },
  {
    label: 'Search Editor',
    description: 'Can create and manage the editorial content such as bookmarks, Q and As, locations, floorplan.',
    value: '8835291a-918c-4fd7-a9ce-faa49f0cf7d9',
  },
  {
    label: 'Security Administrator',
    description:
      'Can read security information and reports, and manage configuration in Microsoft Entra ID and Office 365.',
    value: '194ae4cb-b126-40b2-bd5b-6091b380977d',
  },
  {
    label: 'Security Operator',
    description: 'Creates and manages security events.',
    value: '5f2222b1-57c3-48ba-8ad5-d4759f1fde6f',
  },
  {
    label: 'Security Reader',
    description: 'Can read security information and reports in Microsoft Entra ID and Office 365.',
    value: '5d6b6bb7-de71-4623-b4af-96380a352509',
  },
  {
    label: 'Service Support Administrator',
    description: 'Can read service health information and manage support tickets.',
    value: 'f023fd81-a637-4b56-95fd-791ac0226033',
  },
  {
    label: 'SharePoint Administrator',
    description: 'Can manage all aspects of the SharePoint service.',
    value: 'f28a1f50-f6e7-4571-818b-6a12f2af6b6c',
  },
  {
    label: 'SharePoint Embedded Administrator',
    description: 'Manage all aspects of SharePoint Embedded containers.',
    value: '1a7d78b6-429f-476b-b8eb-35fb715fffd4',
  },
  {
    label: 'Skype for Business Administrator',
    description: 'Can manage all aspects of the Skype for Business product.',
    value: '75941009-915a-4869-abe7-691bff18279e',
  },
  {
    label: 'Teams Administrator',
    description: 'Can manage the Microsoft Teams service.',
    value: '69091246-20e8-4a56-aa4d-066075b2a7a8',
  },
  {
    label: 'Teams Communications Administrator',
    description: 'Can manage calling and meetings features within the Microsoft Teams service.',
    value: 'baf37b3a-610e-45da-9e62-d9d1e5e8914b',
  },
  {
    label: 'Teams Communications Support Engineer',
    description: 'Can troubleshoot communications issues within Teams using advanced tools.',
    value: 'f70938a0-fc10-4177-9e90-2178f8765737',
  },
  {
    label: 'Teams Communications Support Specialist',
    description: 'Can troubleshoot communications issues within Teams using basic tools.',
    value: 'fcf91098-03e3-41a9-b5ba-6f0ec8188a12',
  },
  {
    label: 'Teams Devices Administrator',
    description: 'Can perform management related tasks on Teams certified devices.',
    value: '3d762c5a-1b6c-493f-843e-55a3b42923d4',
  },
  {
    label: 'Teams Telephony Administrator',
    description:
      'Manage voice and telephony features and troubleshoot communication issues within the Microsoft Teams service.',
    value: 'aa38014f-0993-46e9-9b45-30501a20909d',
  },
  {
    label: 'Tenant Creator',
    description: 'Create new Microsoft Entra or Azure AD B2C tenants.',
    value: '112ca1a2-15ad-4102-995e-45b0bc479a6a',
  },
  {
    label: 'Usage Summary Reports Reader',
    description: "Read Usage reports and Adoption Score, but can't access user details.",
    value: '75934031-6c7e-415a-99d7-48dbd49e875e',
  },
  {
    label: 'User Administrator',
    description: 'Can manage all aspects of users and groups, including resetting passwords for limited admins.',
    value: 'fe930be7-5e62-47db-91af-98c3a49a38b1',
  },
  {
    label: 'User Experience Success Manager',
    description: 'View product feedback, survey results, and reports to find training and communication opportunities.',
    value: '27460883-1df1-4691-b032-3b79643e5e63',
  },
  {
    label: 'Virtual Visits Administrator',
    description:
      'Manage and share Virtual Visits information and metrics from admin centers or the Virtual Visits app.',
    value: 'e300d9e7-4a2b-4295-9eff-f1c78b36cc98',
  },
  {
    label: 'Viva Goals Administrator',
    description: 'Manage and configure all aspects of Microsoft Viva Goals.',
    value: '92b086b3-e367-4ef2-b869-1de128fb986e',
  },
  {
    label: 'Viva Pulse Administrator',
    description: 'Can manage all settings for Microsoft Viva Pulse app.',
    value: '87761b17-1ed2-4af3-9acd-92a150038160',
  },
  {
    label: 'Windows 365 Administrator',
    description: 'Can provision and manage all aspects of Cloud PCs.',
    value: '11451d60-acb2-45eb-a7d6-43d0f0125c13',
  },
  {
    label: 'Windows Update Deployment Administrator',
    description:
      'Can create and manage all aspects of Windows Update deployments through the Windows Update for Business deployment service.',
    value: '32696413-001a-46ae-978c-ce0f6b3620d2',
  },
  {
    label: 'Yammer Administrator',
    description: 'Manage all aspects of the Yammer service.',
    value: '810a2642-a034-447f-a5e8-41beaa378541',
  },
];
